import React from 'react';
import Classnames from 'classnames';



import PostHogService from '../../services/posthog';
import PostHogEvents from '../../constants/posthog-events';

import './checklist-item-marketing.scss';

export default class ChecklistItemMarketing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checked: false,
            sublist: props.sublist || false
        };

        this.renderIcon = this.renderIcon.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation(); // don't affect parent list items

        // if the click is for the footnote links then don't
        // toggle the checkbox.
        if (['footnote-link', 'sup'].indexOf(e.target.localName) > -1) {
            return;
        }

        const newCheckedState = !this.state.checked;
        this.setState({
            checked: newCheckedState
        });

        // title is a React element, and PostHog deep-copies event properties, so
        // sending it walks the whole React tree and overflows the stack. Send the
        // plain text instead.
        PostHogService.capture(PostHogEvents.CHECKLIST_ITEM_CHECKED, {
            item_text: (this.props.text || '').replace(/<[^>]*>/g, '').trim().slice(0, 200),
            checked: newCheckedState
        });
    }

    renderIcon() {
        if (this.state.sublist) {
            return this.state.checked ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="checklist-circle-icon checked">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
            ) : (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="checklist-circle-icon">
                    <circle cx="12" cy="12" r="10"></circle>
                </svg>
            );
        }

        return this.state.checked ? (
            <div className="checklist-custom-checkbox checked">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
            </div>
        ) : (
            <div className="checklist-custom-checkbox"></div>
        );
    }

    render() {
        let classes = Classnames({
            'checklist-item': true,
            'is-checked': this.state.checked,
            'is-sublist': this.state.sublist
        });

        return (
            <li className={classes} onClick={this.handleClick}>
                <div className="checklist-item-icon">
                    {this.renderIcon()}
                </div>
                <div className={'checklist-item-entries'}>
                    {this.props.title}
                    {this.props.innerList}
                </div>
            </li>
        );
    }
}
